import { Component } from '@angular/core';

@Component({
  selector: 'app-card-banner-overview-section',
  standalone: true,
  imports: [],
  templateUrl: './card-banner-overview-section.component.html',
  styleUrl: './card-banner-overview-section.component.scss'
})
export class CardBannerOverviewSectionComponent {

}
